import {
  getInterestWhitelist,
  getLayoutWhitelist,
  getMediaTypesWhitelist,
  getSensorCategoryTypesWhitelist,
  getSensorTypesWhitelist,
} from 'src/app/helpers/config.helper';
import { InterestsTypes } from 'src/enums/interests.enum';
import { FileUploadTypes, SensorCategoryType, SensorType } from 'src/enums/nginr-type.enum';
import { MediaType } from 'src/enums/surfer.enums';

import { ConfigSettingsResultType } from 'src/app/services/config-settings/config-settings.service.type';
import { finalUrlsConfig } from 'src/configs/url.config';
import { ReportTypes } from 'src/enums/logger-export.enum';

export type SystemConfigType = {
  sensorTypes: {
    -readonly [key in keyof typeof SensorType]: boolean;
  };
  mediaTypes: {
    -readonly [key in keyof typeof MediaType]: boolean;
  };
  interests: {
    -readonly [key in keyof typeof InterestsTypes]: boolean;
  };
  reportTypes: string[];
  webFrontendDesign: {
    Layout: number;
  };
  // system: {
  //   type: SystemType;
  // };
  sensorCategoryTypes: {
    -readonly [key in keyof typeof SensorCategoryType]: boolean;
  };
  sensorUrls: {
    webSiteUrls: string[];
    newsSiteUrls: string[];
    blacklistUrls: string[];
    courtRecordUrls: string[];
    socialMediaUrls: string[];
  };
  mapURL: {
    landURL: string;
    satelliteURL: string;
  };

  fileUploadTypes: {
    AllowImage: boolean;
    AllowVideo: boolean;
  };

  systemLogin: {
    active: boolean;
  };
};

const isBuildRun = window.EXECUTABLE_TYPE && window.EXECUTABLE_TYPE !== '{{EXECUTABLE_TYPE}}';
const getSystemConfig = (): SystemConfigType => {
  return {
    sensorTypes: {
      Camera: false,
      Card_Reader: false,
      CB_Manual: false,
      Web_Manual: false,
      Other: false,
      Web_Site: false,
      News_Site: false,
      Blacklist: false,
      Court_Record: false,
      Social_Media: false,
      Fence_Node: false,
      batP: false,
    },

    sensorCategoryTypes: {
      OSS: false,
      File_Upload: false,
      Streaming: false,
    },

    mediaTypes: {
      Video: false,
      Image: false,
      Zipped: false,
      Ones: false,
      Siem: false,
      Talk: false,
      Document: false,
      Unknown: false,
      Fence_Data: false,
      Keypad: false,
      batP: false,
      SeNot: false,
    },
    reportTypes: [],
    interests: {
      Communication: false,
      Incident: false,
      Location: false,
      Object: false,
      Person: false,
      Sensor: false,
      Vehicle: false,
      Functional_Area: false,
      Relation: false,
      Enterprise: false,
      Industry: false,
      Topic: false,
      Agent: false,
      Transaction: false,
    },

    webFrontendDesign: {
      Layout: 0,
    },
    // system: {
    //   type: SystemType[window.SYS_TYPE as keyof typeof SystemType] ?? SystemType.RED,
    // },

    fileUploadTypes: {
      AllowVideo: false,
      AllowImage: false,
    },

    sensorUrls: {
      blacklistUrls: [],
      courtRecordUrls: [],
      newsSiteUrls: [],
      socialMediaUrls: [],
      webSiteUrls: [],
    },
    mapURL: {
      landURL: '',
      satelliteURL: '',
    },
    systemLogin: {
      active: false,
    },
  };
};

const systemConfig = {
  ...getSystemConfig(),
};

export const systemConfigSetter = (data: ConfigSettingsResultType) => {
  systemConfig.sensorTypes.Camera = data.sensorTypes.includes(SensorType.Camera);
  systemConfig.sensorTypes.Card_Reader = data.sensorTypes.includes(SensorType.Card_Reader);
  systemConfig.sensorTypes.CB_Manual = data.sensorTypes.includes(SensorType.CB_Manual);
  systemConfig.sensorTypes.Web_Manual = data.sensorTypes.includes(SensorType.Web_Manual);
  systemConfig.sensorTypes.Other = data.sensorTypes.includes(SensorType.Other);
  systemConfig.sensorTypes.Web_Site = data.sensorTypes.includes(SensorType.Web_Site);
  systemConfig.sensorTypes.News_Site = data.sensorTypes.includes(SensorType.News_Site);
  systemConfig.sensorTypes.Blacklist = data.sensorTypes.includes(SensorType.Blacklist);
  systemConfig.sensorTypes.Court_Record = data.sensorTypes.includes(SensorType.Court_Record);
  systemConfig.sensorTypes.Social_Media = data.sensorTypes.includes(SensorType.Social_Media);
  systemConfig.sensorTypes.Fence_Node = data.sensorTypes.includes(SensorType.Fence_Node);
  systemConfig.sensorTypes.batP = data.sensorTypes.includes(SensorType.batP);

  systemConfig.sensorCategoryTypes.OSS = data.sensorCategoryTypes.includes(SensorCategoryType.OSS);
  systemConfig.sensorCategoryTypes.File_Upload = data.sensorCategoryTypes.includes(SensorCategoryType.File_Upload);
  systemConfig.sensorCategoryTypes.Streaming = data.sensorCategoryTypes.includes(SensorCategoryType.Streaming);

  systemConfig.mediaTypes.Video = data.mediaTypes.includes(MediaType.Video);
  systemConfig.mediaTypes.Image = data.mediaTypes.includes(MediaType.Image);
  systemConfig.mediaTypes.Zipped = data.mediaTypes.includes(MediaType.Zipped);
  systemConfig.mediaTypes.Ones = data.mediaTypes.includes(MediaType.Ones);
  systemConfig.mediaTypes.Siem = data.mediaTypes.includes(MediaType.Siem);
  systemConfig.mediaTypes.Talk = data.mediaTypes.includes(MediaType.Talk);
  systemConfig.mediaTypes.Document = data.mediaTypes.includes(MediaType.Document);
  systemConfig.mediaTypes.Unknown = data.mediaTypes.includes(MediaType.Unknown);
  systemConfig.mediaTypes.Fence_Data = data.mediaTypes.includes(MediaType.Fence_Data);
  systemConfig.mediaTypes.Keypad = data.mediaTypes.includes(MediaType.Keypad);
  systemConfig.mediaTypes.batP = data.mediaTypes.includes(MediaType.batP);
  systemConfig.mediaTypes.SeNot = data.mediaTypes.includes(MediaType.SeNot);

  systemConfig.reportTypes = data.reportTypes.map((item) => ReportTypes[item]);

  systemConfig.interests.Communication = data.interestTypes.includes(InterestsTypes.Communication);
  systemConfig.interests.Incident = data.interestTypes.includes(InterestsTypes.Incident);
  systemConfig.interests.Location = data.interestTypes.includes(InterestsTypes.Location);
  systemConfig.interests.Object = data.interestTypes.includes(InterestsTypes.Object);
  systemConfig.interests.Person = data.interestTypes.includes(InterestsTypes.Person);
  systemConfig.interests.Sensor = data.interestTypes.includes(InterestsTypes.Sensor);
  systemConfig.interests.Vehicle = data.interestTypes.includes(InterestsTypes.Vehicle);
  systemConfig.interests.Functional_Area = data.interestTypes.includes(InterestsTypes.Functional_Area);
  systemConfig.interests.Relation = data.interestTypes.includes(InterestsTypes.Relation);
  systemConfig.interests.Enterprise = data.interestTypes.includes(InterestsTypes.Enterprise);
  systemConfig.interests.Industry = data.interestTypes.includes(InterestsTypes.Industry);
  systemConfig.interests.Topic = data.interestTypes.includes(InterestsTypes.Topic);
  systemConfig.interests.Agent = data.interestTypes.includes(InterestsTypes.Agent);
  systemConfig.interests.Transaction = data.interestTypes.includes(InterestsTypes.Transaction);

  systemConfig.fileUploadTypes.AllowVideo = data.fileUploadTypes.includes(FileUploadTypes.VIDEO);
  systemConfig.fileUploadTypes.AllowImage = data.fileUploadTypes.includes(FileUploadTypes.IMAGE);

  systemConfig.sensorUrls.blacklistUrls = data.blacklistUrls;
  systemConfig.sensorUrls.courtRecordUrls = data.courtRecordUrls;
  systemConfig.sensorUrls.newsSiteUrls = data.newsSiteUrls;
  systemConfig.sensorUrls.socialMediaUrls = data.socialMediaUrls;
  systemConfig.sensorUrls.webSiteUrls = data.webSiteUrls;

  systemConfig.mapURL.landURL = data.landUrl;
  systemConfig.mapURL.satelliteURL = data.satelliteUrl;

  systemConfig.systemLogin.active = data.systemLoginStatus === 'Active';
  systemConfig.webFrontendDesign.Layout = data.webLayoutDesignType;
};

export const INTERESTS_WHITELIST = () => getInterestWhitelist(systemConfig.interests);
export const MEDIA_TYPE_WHITELIST = () => getMediaTypesWhitelist(systemConfig.mediaTypes);
export const SENSOR_TYPE_WHITELIST = () => getSensorTypesWhitelist(systemConfig.sensorTypes);
export const SENSOR_CATEGORY_TYPE_WHITELIST = () => getSensorCategoryTypesWhitelist(systemConfig.sensorCategoryTypes);
export const LAYOUTVIEW = () => getLayoutWhitelist(systemConfig.webFrontendDesign.Layout);

export const SENSOR_URL_LIST = () => systemConfig.sensorUrls;

export const LAND_MAP_URL = () => systemConfig.mapURL.landURL;
export const SATELLITE_MAP_URL = () => systemConfig.mapURL.satelliteURL;
export const LOGIN_URL = systemConfig.systemLogin.active ? `${finalUrlsConfig().systemLoginURL}/Login` : '/Login';

// export const FONT_FAMILY = getFontFamily(LAYOUTVIEW, 'ar' as LanguagePreferenceEnum);

export default systemConfig;
